import {get} from 'lodash'
import React, {useState, useContext} from "react";
import {DataGridWrapper} from "../../../../Utils/DataGridWrapper/DataGridWrapper";
import './OrganizationUnitTable.scss'
import {RemoveOrgCell} from "../RemoveOrgCell/RemoveOrgCell";
import {getAdminOrganizationsPaginationAPI} from "../../../../Services/api";
import {getAdminOrganizations} from "../../../../Utils/User/UserLib";
import {format} from "date-fns";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import {buttonColors} from "../../../Pickers/InputTheme";
import {GridReactContext} from "../../../../Utils/DataGridWrapper/GridContext";
import { AddOrganizationsModal } from "../../../SuperAdmin/EditAddOrganizationsToCompany/AddOrganizationsModal/AddOrganizationsModal";
import { EditOrgNameCell } from "../EditOrgNameCell/EditOrgNameCell";
import { UserReactContext } from "../../../../contexts/UserContext";
import { adminCreateOrganizationsForCompany } from "../../../../Services/api";
import { I18nReactContext } from "../../../../contexts/I18nContext";
import {invalidateQueries, queryKeys} from "../../../Hooks/useQueryHooks";

const getOrganizationalUnitColumns = ({i18n}) => {

    return [
        {
            field: 'orgName',
            headerName: i18n.translate("organizationalUnitTable.columns.organizationalUnitName"),
            minWidth: 220,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}}>{get(params, "row.organization.orgName")}</div>,
        },
        {
            field: 'createdAt',
            headerName: i18n.translate("organizationalUnitTable.columns.createAt"),
            minWidth: 150,
            align: 'right',
            sortable: false,
            renderCell: (params) => <div style={{width: '100%'}}>{format(params.value, 'dd/MM/yyyy')}</div>,
        },
        {
            field: 'delete',
            headerName: i18n.translate("organizationalUnitTable.columns.delete"),
            minWidth: 180,
            align: 'right',
            sortable: false,
            renderCell: (params) => <RemoveOrgCell organizationId={get(params, "row.organization.id")} organizationName={get(params, "row.organization.orgName")}/>,
        },
        {
            field: 'update',
            headerName: i18n.translate("organizationalUnitTable.columns.updateOrgName"),
            minWidth: 250,
            align: 'right',
            sortable: false,
            renderCell: (params) => <EditOrgNameCell organizationId={get(params, "row.organization.id")} organizationName={get(params, "row.organization.orgName")}/>,
        },
    ];
}

const tableFilters = {
    showFilters: {
        search: true,
    },
    filterValues: {},
    filterData: {}
}

const convertData = (organizationalUnits) => {
    return organizationalUnits;
}

const paginationModel = {
    page: 0,
    pageSize: 20,
}

export const OrganizationUnitTable = () => {
    const {i18n} = useContext(I18nReactContext);
    const [addOrgModalOpen, setAddOrgModalOpen] = useState(false)
    const gridContext = useContext(GridReactContext)
    const userContext = useContext(UserReactContext)

    const openAddOrgModal = () => {
        setAddOrgModalOpen(true)
    }

    const closeAddOrgModal = () => {
        setAddOrgModalOpen(false)
    }

    const onCreateOrganizations = async ({organizations}) => {
        closeAddOrgModal()
        await adminCreateOrganizationsForCompany({companyId: userContext.getUserCompanyId(), organizations})
        invalidateQueries({queryKeys: [
            queryKeys.adminOrganizations(),
            queryKeys.uniqueSignDocs(false),
            queryKeys.uniqueSignDocs(true)
        ]})
        gridContext.triggerTableRefresh()
    }

    const getColumns = async () => {
        return getOrganizationalUnitColumns({i18n})
    }
    const apiToGetData = async ({paginationModel, filterModel}) => {
      return getAdminOrganizationsPaginationAPI({paginationModel, filterModel, withAdminPermission: true});
    }

    const tableButtons = [
        {
            icon: <BadgeOutlinedIcon/>,
            color: buttonColors.GREY,
            text: i18n.translate('settingsPage.buttons.addOrg'),
            onClick: ({paginationModel, filterModel, sortModel}) => {
                openAddOrgModal()
            }
        }
    ]

    return <>
        <DataGridWrapper
                        filterModel={tableFilters}
                        disableColumnFilter
                        paginationModel={paginationModel}
                        getColumns={getColumns}
                        apiToGetData={apiToGetData}
                        dataConverter={convertData}
                        buttons={tableButtons}
        />
        {addOrgModalOpen && <AddOrganizationsModal
            open={addOrgModalOpen}
            onClose={closeAddOrgModal}
            onCreateOrganizations={onCreateOrganizations}
            />}
    </>
}